import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HecInputComponent } from './hec-input/hec-input.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PreventCutCopyPasteDirective } from '../../directives/preventCutCopyPaste';
import { OnlyNumericCharAllowedDirective } from '../../directives/onlyNumericChars';
import { OnlyAlphabetsAllowedDirective } from '../../directives/onlyAlphabets';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { SelectDropDownModule } from 'ngx-select-dropdown';
import { MatDialogModule, MatButtonModule, MatIconModule, MatInputModule, MatNativeDateModule, MatTreeModule, MatMenuModule, MatExpansionModule, MatBottomSheetModule, MatButtonToggleModule, MatGridListModule, MatListModule, MatTooltipModule, MatTableModule, MatTabsModule, MatDividerModule, MatToolbarModule, MatCardModule, MatChipsModule, MatProgressBarModule, MatProgressSpinnerModule, MatSliderModule, MatPaginatorModule, MatSortModule, MatSidenavModule, MatSnackBarModule, MatStepperModule, MatAutocompleteModule, MatFormFieldModule } from '@angular/material';
import { MaxLengthNumberDirective } from '../../directives/numberMaxLength';
import { CheckpatternDirective } from '../../directives/checkpattern.directive';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { OnlyNumericCharWithoutDotAllowedDirective } from '../../directives/onlyNumericwithoutDot';
import { MaterialPreviewModule } from '../../views/partials/content/general/material-preview/material-preview.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { CoreModule } from '../../core/core.module';
import { OnlyAlphabetsWithSpacesAllowedDirective } from '../../directives/onlyAlphabetsWithSpaces';
// import { Ng2ImgMaxModule } from 'ng2-img-max';
import { EducationFormComponent } from './education-form/education-form.component';
import { ErrorMsgComponentComponent } from './error-msg-component/error-msg-component.component';
import { ProfilePictureUpdateComponent } from './profile-picture-update/profile-picture-update.component';
import { QuestionnaireComponent } from './modal/questionnaire/questionnaire.component';
import { ProgressComponent } from './progress-component/progress-component.component';
import { WarningModalComponent } from './modal/warning-modal/warning-modal.component';
import { SuccessDasComponent } from './modal/success-das/success-das.component';
import { FilterPipe } from '../../directives/searchFilter.directive';
import { MessagingService } from './messaging.service';
import { AppLoaderComponent } from './app-loader/app-loader.component';
import { InvalidInputFocusDirective } from '../../directives/invalidInputFocusDirective';
//import { SpinnerModule } from "angular2-spinner/dist";
import { MatTableResponsiveComponent } from './mat-table-responsive/mat-table-responsive.component';
import { WelcomeComponent } from './modal/welcome/welcome.component';
import { NgxNumberSpinnerModule } from 'ngx-number-spinner';
import { CommentsListComponent } from './modal/comments-list/comments-list.component';
import { DocumentViewerComponent } from './modal/document-viewer/document-viewer.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { PdfViewerComponent } from './modal/pdf-viewer/pdf-viewer.component';
import { ConfirmationModalComponent } from './confirmation-modal/confirmation-modal.component';
import { ConditionalErrorsModalComponent } from './conditional-errors-modal/conditional-errors-modal.component';
import { EmploymentFormComponent } from './employment-form/employment-form.component';
import { UserManualViewerComponent } from './user-manual-viewer/user-manual-viewer.component';
import { EligibilityModalComponent } from './modal/eligibility-modal/eligibility-modal.component';
import { ModalComponent } from './modal/modal/modal.component';
import { PopupComponent } from './modal/popup/popup.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';

import { InternationalPhoneNumberModule } from 'ngx-international-phone-number';
import { EmploymentDetailsComponent } from './employment-details/employment-details.component';
import { EducationComponent } from './education/education.component';
import { ProfileComponent } from './profile/profile.component';
import { CourseFormComponent } from './course-form/course-form.component';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { UploadDocumentsModalComponent } from './modal/upload-documents-modal/upload-documents-modal.component';
@NgModule({
  declarations: [
    HecInputComponent,
    PreventCutCopyPasteDirective,
    OnlyNumericCharAllowedDirective,
    OnlyAlphabetsAllowedDirective,
    MaxLengthNumberDirective,
    CheckpatternDirective,
    OnlyNumericCharWithoutDotAllowedDirective,
    FilterPipe,
    InvalidInputFocusDirective,
    OnlyAlphabetsWithSpacesAllowedDirective, EducationFormComponent, ErrorMsgComponentComponent, ProfilePictureUpdateComponent, QuestionnaireComponent, ProgressComponent, WarningModalComponent, SuccessDasComponent, AppLoaderComponent,
    // TimeAgoPipe,
    MatTableResponsiveComponent,
    WelcomeComponent,
    CommentsListComponent,
    DocumentViewerComponent,
    PdfViewerComponent,
    ConfirmationModalComponent,
	ConditionalErrorsModalComponent,
	EmploymentFormComponent,
	UserManualViewerComponent,
	EligibilityModalComponent,
  ModalComponent,
  PopupComponent,
  EmploymentDetailsComponent,
  EducationComponent,
  ProfileComponent,
  CourseFormComponent,
  UploadDocumentsModalComponent
  ],
  imports: [
    CommonModule,
    CollapseModule,
    FormsModule,
    NgbModule,
    //  SpinnerModule,
    ReactiveFormsModule,
    ModalModule.forRoot(),
    TooltipModule.forRoot(),
    SelectDropDownModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatButtonModule,
    MatDatepickerModule,
    MatSelectModule,
    InternationalPhoneNumberModule,
    MatCheckboxModule,
    MatRadioModule,
    MatButtonModule,
    MatCardModule,
    MatChipsModule,
    MatSelectModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatSliderModule,
    MatPaginatorModule,
    MatSortModule,
    MatSidenavModule,
    MatSnackBarModule,
    MatStepperModule,
    MatToolbarModule,
    MatDividerModule,
    MatTabsModule,
    MatTableModule,
    MatTooltipModule,
    MatListModule,
    MatGridListModule,
    MatButtonToggleModule,
    MatBottomSheetModule,
    MatExpansionModule,
    MatMenuModule,
    MaterialPreviewModule,
    MatTreeModule,
    MatSelectModule,
    ReactiveFormsModule,
    MatRadioModule,
    MatIconModule,
    MatInputModule,
    MatDatepickerModule,
    MatProgressSpinnerModule,
    MatCheckboxModule,
    MatAutocompleteModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
    MatRadioModule,
    NgxMatSelectSearchModule,
    CoreModule,
    // Ng2ImgMaxModule,
    NgxNumberSpinnerModule,
    NgxExtendedPdfViewerModule,
    NgxIntlTelInputModule,
	MatSlideToggleModule
  ],
  exports: [
    HecInputComponent,
    MatButtonModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatDialogModule,
    MatIconModule,
    MatInputModule,
    MatNativeDateModule,
    NgxIntlTelInputModule,
    InternationalPhoneNumberModule,
    MatRadioModule,
    MatCardModule,
    MatChipsModule,
    MatSelectModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatSliderModule,
    MatPaginatorModule,
    MatSortModule,
    MatSidenavModule,
    MatSnackBarModule,
    MatStepperModule,
    MatToolbarModule,
    MatDividerModule,
    MatTabsModule,
    MatTableModule,
    MatTooltipModule,
    MatListModule,
    MatGridListModule,
    MatButtonToggleModule,
    MatBottomSheetModule,
    MatExpansionModule,
    MatMenuModule,
    MaterialPreviewModule,
    MatTreeModule,
    MatSelectModule,
    ReactiveFormsModule,
    MatRadioModule,
    MatIconModule,
    MatInputModule,
    MatDatepickerModule,
    MatProgressSpinnerModule,
    MatCheckboxModule,
    MatAutocompleteModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
    MatRadioModule,
    PreventCutCopyPasteDirective,
    OnlyNumericCharAllowedDirective,
    OnlyAlphabetsAllowedDirective,
    MaxLengthNumberDirective,
    CheckpatternDirective,
    OnlyNumericCharWithoutDotAllowedDirective,
    InvalidInputFocusDirective,
    NgxMatSelectSearchModule,
    // Ng2ImgMaxModule,
    EducationFormComponent,
    ErrorMsgComponentComponent,
    QuestionnaireComponent,
    ProgressComponent, WarningModalComponent, SuccessDasComponent, FilterPipe, AppLoaderComponent,
    ProfilePictureUpdateComponent,
    // TimeAgoPipe,
    MatTableResponsiveComponent,
    NgxNumberSpinnerModule,
	NgxExtendedPdfViewerModule,
	EmploymentFormComponent,
	UserManualViewerComponent,
	PdfViewerComponent,
	EligibilityModalComponent,
  EmploymentDetailsComponent,
  EducationComponent,
  ProfileComponent,
  CourseFormComponent,
  MatSlideToggleModule,
  UploadDocumentsModalComponent
  ],
  entryComponents: [
    QuestionnaireComponent,
    WarningModalComponent,
    SuccessDasComponent,
    WelcomeComponent,
    CommentsListComponent,
    DocumentViewerComponent,
	PdfViewerComponent,
	EligibilityModalComponent,
  ModalComponent,
  PopupComponent,
  UploadDocumentsModalComponent,
	ConfirmationModalComponent,
	ConditionalErrorsModalComponent,
  ],
  providers: [

  ]
})

export class SharedModule { }
